import { Box, Chip, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState, useContext, useMemo } from "react";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";

export function UsersFilter({ onFiltered, initialUsers = [] }) {
  const [users, setUsers] = useState([]);
  const [selecteds, setSelecteds] = useState(initialUsers);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    loadUsers();
  }, []);

  // Memoiza o array de usuários iniciais para evitar renderizações desnecessárias
  const memoizedInitialUsers = useMemo(() => initialUsers || [], [JSON.stringify(initialUsers)]);

  useEffect(() => {
    setSelecteds(memoizedInitialUsers);
  }, [memoizedInitialUsers]);

  const loadUsers = async () => {
    try {
      const { data } = await api.get(`/users/list`);
      const userList = data.map((u) => ({ id: u.id, name: u.name }));
      setUsers(userList);
    } catch (err) {
      console.error('Erro ao carregar usuários:', err);
    }
  };

  const handleChange = (value) => {
    setSelecteds(value);
    onFiltered(value);
  };



  return (
    <Box style={{ padding: "2px 10px" }}>
      <Autocomplete
        multiple
        size="medium"
        options={users || []}
        value={selecteds || []}
        onChange={(e, v) => handleChange(v)}
        getOptionLabel={(option) => option?.name || ""}
        getOptionSelected={(option, value) => option?.id === value?.id}
        ListboxProps={{
          style: { 
            maxHeight: '200px', // Altura para mostrar 2 usuários completos
            overflow: 'auto', // Permitir scroll se houver mais usuários
            padding: '8px 0', // Padding interno para melhor espaçamento
            borderRadius: '4px', // Bordas arredondadas
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)' // Sombra sutil
          }
        }}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              style={{
                backgroundColor: "#0872b9",
                textShadow: "1px 1px 1px #000",
                color: "white",
                height: "20px",
                fontSize: "11px"
              }}
              label={option?.name || ""}
              {...getTagProps({ index })}
              size="small"
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="Filtro por Usuários"
            size="medium"
            style={{
              marginBottom: "4px",
              minWidth: "250px",
              width: "100%"
            }}
            InputProps={{
              ...params.InputProps,
              style: {
                fontSize: "14px",
                padding: "8px 12px"
              }
            }}
          />
        )}
      />
    </Box>
  );
}
